/**
 * Ключ перевода для отказа оплаты вне окна продаж (аудит денег 2026-10,
 * I2): бэкенд отвечает кодом в extensions.cause и русским message, а
 * зритель должен видеть текст на своём языке. null: это не такой отказ.
 */
export function salesClosedMessageKey(cause: unknown): string | null {
  if (cause === "PRODUCT_SALES_FINISHED") return "payment.salesFinishedError";
  if (cause === "PRODUCT_NOT_PUBLISHED") {
    return "payment.productNotPublishedError";
  }
  return null;
}
